var _defs, _rect, _rect2, _rect3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferencesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#79828b;}.cls-2{fill:#fff;stroke:#79828b;stroke-miterlimit:10;stroke-width:2px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.17,
    y: 2.44,
    width: 2,
    height: 19.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.17,
    y: 2.44,
    width: 2,
    height: 19.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.17,
    y: 2.44,
    width: 2,
    height: 19.12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 4.83,
    cy: 8.28,
    r: 2.62
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11.98,
    cy: 16.29,
    r: 2.62
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.17,
    cy: 8.28,
    r: 2.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencesIcon);
export default __webpack_public_path__ + "static/media/preferences_icon.f05775819dfc6cc361f524c30202a7eb.svg";
export { ForwardRef as ReactComponent };